import { FC } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../shared/components/Icon";

interface VideoCardProps {
  href: string;
  image: string;
  title: string;
  caption?: string;
  wide?: boolean;
  external?: boolean;
}

const VideoCard: FC<VideoCardProps> = ({
  href,
  image,
  title,
  caption = "İzlemek için: YouTube",
  wide = false,
  external = false,
}) => {
  const className = `it-vcard${wide ? " it-vcard--wide" : ""}`;
  const content = (
    <>
      <img src={image} alt="" loading="lazy" />
      <span className="it-play">
        <Icon name="play" />
      </span>
      <span className="it-cap">
        <small>{caption}</small>
        <h4>{title}</h4>
      </span>
    </>
  );

  return external ? (
    <a className={className} href={href} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    <Link className={className} to={href}>
      {content}
    </Link>
  );
};

export default VideoCard;
